import React from "react";
import Logo from "../../../assets/img/hvezda.png";
import {
  Row,
  Col,
  Card,
  Button,
  Image,
  Placeholder,
  Table,
  Alert,
  Modal,
} from "react-bootstrap";
import {
  FaBuilding,
  FaFilePdf,
  FaCheckCircle,
  FaTimesCircle,
  FaTrash,
  FaFileImage,
} from "react-icons/fa";
import _params from "../../../componets/_params"
import { Markup } from "react-render-markup";

class RepairPriceQuotation extends React.Component {
  ext = window.document;
  state = {
    loading: false,
    data: {},
    subTotal: 0,
    vatTotal: 0,
    total: 0,
    printDialog: false,
    confirm: false,
    confirmType: -1,
  };

  getQuotation = async (pid, print) => {
    if (pid == null) pid = this.props.params.id;
    this.setState({ loading: true });
    const _res = await this.props._api({
      ...this.props,
      method: "get",
      endpoint: "/api/service/Quotation/" + pid,
      param: "",
      successText: ""
    });

    this.setState({ loading: false });
    if (_res.status == 200) {
      let subTotal = 0;
      let vatTotal = 0;
      _res.data.articles.map((i) => {
        subTotal = subTotal + i.articlePrice * i.articleQty;
      });
      if (_res.data.invoiceCurrCode == "CZK")
        vatTotal = (subTotal / 100) * _res.data.invoiceRate;

      this.setState({
        data: _res.data,
        subTotal: subTotal,
        vatTotal: vatTotal,
        total: subTotal + vatTotal,
      });
      this.props.setHeaderPage({
        Icon: <FaBuilding className="c-placeholder c-green" />,
        Title: "Cenová nabídka",
        SubTitle: "Tady potvrdíte nebo zamítnete cenovou nabídku.",
        Buttons: _res.data.forConfirm ? (
          <>
            <Button
              variant="outline-success me-4"
              onClick={() =>
                this.setState({ confirm: true, confirmType: 2530 })
              }
            >
              <FaCheckCircle /> <strong> Souhlasím</strong>
            </Button>
            <Button
              variant="outline-danger me-4"
              onClick={() =>
                this.setState({ confirm: true, confirmType: 2550 })
              }
            >
              <FaTimesCircle /> <strong> Nesouhlasím</strong>
            </Button>
            <Button
              variant="outline-secondary"
              onClick={() =>
                this.setState({ confirm: true, confirmType: 3700 })
              }
            >
              <FaTrash /> <strong> Zlikvidovat</strong>
            </Button>
          </>
        ) : (
          <Alert variant="success">
            K této cenové nabídce již byla zaslána odpověď
          </Alert>
        ),
      });
      if (print != null) {
        setTimeout(() => {
          document.getElementById("no-print").innerHTML = "";
          document.getElementById("no-print-2").innerHTML = "";
          document.body.innerHTML =
            document.getElementById("print-content").innerHTML;
          window.print();
        }, 200);
      }
    }
    if (_res.status != 200)
      this.props.setToast(_res.data, "Něco se nepovedlo", "ERROR");

    return;
  };

  printDialog = () => {
    this.setState({ printDialog: true });
    /* var externalWindow = window.open(
      "",
      "_blank",
      "width=1000,height=725,left=200,top=200"
    );
    
    externalWindow.document.head.innerHTML = document.head.innerHTML;
    externalWindow.document.body.innerHTML =
            document.getElementById("print-content").innerHTML;
    externalWindow.document.getElementById("no-print").innerHTML = "";
    externalWindow.document.getElementById("no-print-2").innerHTML = "";
    externalWindow.print(); */
  };

  componentDidMount() {
    if (this.props.ip.indexOf("192.168.") == -1) window.location.replace("https://old.britex.cz" + window.location.pathname + window.location.search)
    
    this.getQuotation(
      this.props.getParams[0].get("pid"),
      this.props.getParams[0].get("print")
    );
    this.props.setHeaderPage({
      Icon: <FaBuilding className="c-placeholder c-green" />,
      Title: "Cenová nabídka",
      SubTitle: "Tady potvrdíte nebo zamítnete cenovou nabídku.",
    });
  }

  render() {
    return (
      <>
        {(this.state.confirm || this.state.printDialog) && (
          <Modal
            show={this.state.confirm || this.state.printDialog}
            onHide={() => this.setState({ confirm: false, printDialog: false })}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            keyboard={false}
            backdrop="static"
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                <Image src={Logo} className="c-logo c-squircle me-2" />
                {this.state.confirm && <>Potvrzení cenové nabídky</>}
                {this.state.printDialog && <>Tiskový náhled</>}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.state.confirmType == 2530 && (
                <>
                  <h5>Souhlasím s cenovou nabídkou</h5>
                  <p>
                    <Alert variant="success">
                      Opravdu souhlasíte s cenovou nabídkou v hodnotě{" "}
                      {this.state.data.invoiceCurrCode}{" "}
                      {Number(this.state.total).toFixed(2)} ?
                    </Alert>
                  </p>
                </>
              )}
              {this.state.confirmType == 2550 && (
                <>
                  <h5 className="mb-4">Nesouhlasím s cenovou nabídkou</h5>
                  <p>
                    <Alert variant="danger">
                      Nesouhlasím s cenovým návrhem uhradím poplatek za kontrolu
                      (případnou diagnostiku) zařízení ve výši
                      {" " + this.state.data.invoiceCurrCode + " "}
                      {this.state.data.invoiceCurrCode == "CZK"
                        ? Number(
                            this.state.data.diagPrice *
                              ((100 + this.state.data.invoiceRate) / 100)
                          ).toFixed(2) + " "
                        : this.state.data.diagPrice + " "}
                      s DPH. V této ceně je zahrnuta i cena dopravného.
                    </Alert>
                  </p>
                </>
              )}
              {this.state.confirmType == 3700 && (
                <>
                  <h5 className="mb-4">Zařízení chci ekologicki zlikvidovat</h5>
                  <p>
                    <Alert variant="secondary">
                      S cenovou nabídkou nesouhlasím a prosím o ekologickou
                      likvidaci, nepožaduji jeho navrácení
                    </Alert>
                  </p>
                </>
              )}
              {this.state.printDialog && (

                <>
                  <iframe
                    src={window.location.toString().indexOf("pid=") > -1 ? window.location + "&print" : window.location + "?print"}
                    width="100%"
                    height="500"
                    allowfullscreen
                    sandbox
                  />
                </>
              )}
            </Modal.Body>
            {!this.state.printDialog && (
              <Modal.Footer>
                <Button
                  variant="outline-danger"
                  onClick={() =>
                    this.setState({ confirm: false, printDialog: false })
                  }
                >
                  Zrušit
                </Button>
                <Button
                  variant="outline-success"
                  onClick={() =>
                    document.getElementById("print-content").print()
                  }
                >
                  Potvrdit
                </Button>
              </Modal.Footer>
            )}
          </Modal>
        )}
        <Row className="mt-4">
          <Col xs={12}>
            <Card id="print-content">
              <Card.Body>
                <Row>
                  {this.state.data.docNo ? (
                    <Col
                      xs={10}
                      className="d-flex align-item-center text-center align-middle"
                    >
                      <Image src={Logo} className="c-logo c-squircle me-2" />
                      <span className="h5 mt-1">
                        <strong>
                          Cenová nabídka č.: {this.state.data.docNo}
                        </strong>
                      </span>
                    </Col>
                  ) : (
                    <Col xs={10}>
                      <Placeholder animation="glow">
                        <Placeholder xs={10} />
                      </Placeholder>
                    </Col>
                  )}

                  <Col
                    xs={2}
                    id="no-print"
                    className="d-flex justify-content-end"
                  >
                    {this.state.data.docNo ? (
                      <Button variant="light" onClick={this.printDialog}>
                        <FaFilePdf className="c-red" /> <strong>TISK</strong>
                      </Button>
                    ) : (
                      <Placeholder animation="glow">
                        <Placeholder xs={6} />
                      </Placeholder>
                    )}
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col xs={12}>
                    <div className="table-responsive">
                      <Table borderless>
                        <thead>
                          <tr>
                            <th>Zákazník</th>
                            <th>Přístroj</th>
                            <th>Detail</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              {this.state.data.docNo ? (
                                <p>
                                  {this.state.data.invoiceICO?.length > 0 && (
                                    <>
                                      <strong>
                                        IČO: {this.state.data.invoiceICO}
                                      </strong>
                                      <br />
                                    </>
                                  )}
                                  {this.state.data.invoiceName}
                                  <br />
                                  {this.state.data.invoiceStreet}
                                  <br />
                                  {this.state.data.invoiceCity},{" "}
                                  {this.state.data.invoiceCountry},{" "}
                                  {this.state.data.invoiceZipCode}
                                </p>
                              ) : (
                                <>
                                  <Placeholder animation="glow">
                                    <Placeholder xs={6} />
                                  </Placeholder>
                                  <Placeholder animation="glow">
                                    <Placeholder xs={6} />
                                  </Placeholder>
                                  <Placeholder animation="glow">
                                    <Placeholder xs={6} />
                                  </Placeholder>
                                  <Placeholder animation="glow">
                                    <Placeholder xs={6} />
                                  </Placeholder>
                                  <Placeholder animation="glow">
                                    <Placeholder xs={6} />
                                  </Placeholder>
                                </>
                              )}
                            </td>
                            <td>
                              {this.state.data.docNo ? (
                                <p>
                                  <strong>Výrobce: </strong>{" "}
                                  {this.state.data.deviceManuf}
                                  <br />
                                  <strong>Typ: </strong>
                                  {this.state.data.deviceType}
                                  <br />
                                  <strong>IMEI: </strong>
                                  {this.state.data.deviceIMEI}
                                  <br />
                                  <strong>S/N: </strong>
                                  {this.state.data.deviceSN}
                                </p>
                              ) : (
                                <>
                                  <Placeholder animation="glow">
                                    <Placeholder xs={6} />
                                  </Placeholder>
                                  <Placeholder animation="glow">
                                    <Placeholder xs={6} />
                                  </Placeholder>
                                  <Placeholder animation="glow">
                                    <Placeholder xs={6} />
                                  </Placeholder>
                                  <Placeholder animation="glow">
                                    <Placeholder xs={6} />
                                  </Placeholder>
                                  <Placeholder animation="glow">
                                    <Placeholder xs={6} />
                                  </Placeholder>
                                </>
                              )}
                            </td>
                            <td>
                              {this.state.data.docNo ? (
                                <p>
                                  <strong>Zakázka: </strong>{" "}
                                  {this.state.data.docNo}
                                  <br />
                                  <strong>Vaše č.: </strong>
                                  {this.state.data.numAtCard}
                                  <br />
                                  <strong>Datum vystavení: </strong>
                                  {new Date(
                                    this.state.data.dateCreate
                                  ).toLocaleDateString()}
                                  <br />
                                  <strong>Platnost do: </strong>
                                  {new Date(
                                    this.state.data.dateDeadLine
                                  ).toLocaleDateString()}
                                </p>
                              ) : (
                                <>
                                  <Placeholder animation="glow">
                                    <Placeholder xs={6} />
                                  </Placeholder>
                                  <Placeholder animation="glow">
                                    <Placeholder xs={6} />
                                  </Placeholder>
                                  <Placeholder animation="glow">
                                    <Placeholder xs={6} />
                                  </Placeholder>
                                  <Placeholder animation="glow">
                                    <Placeholder xs={6} />
                                  </Placeholder>
                                  <Placeholder animation="glow">
                                    <Placeholder xs={6} />
                                  </Placeholder>
                                </>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <hr />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <strong>Důvod</strong>
                    <br />
                    <br />
                    {this.state.data.docNo ? (
                      <p className="mb-4">{this.state.data.quotationDesc}</p>
                    ) : (
                      <Placeholder animation="glow">
                        <Placeholder xs={12} />
                      </Placeholder>
                    )}
                  </Col>
                </Row>
                <div id="no-print-2">
                  {this.state.data.documents?.length > 0 && (
                    <>
                      <Row>
                        <Col xs={12}>
                          <hr />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                          <strong>Související dokumenty</strong>
                          <br />
                          <br />
                          {this.state.data.documents.map((d, idx) => (
                            <>
                              <Button
                                key={"btn-doc-" + idx}
                                variant="light"
                                onClick={this.printDialog}
                              >
                                <FaFileImage className="me-2" />{" "}
                                <strong>{d.documentName}</strong>
                              </Button>
                            </>
                          ))}
                        </Col>
                      </Row>
                    </>
                  )}
                </div>
                <Row>
                  <Col xs={12}>
                    <hr />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <div className="table-responsive">
                      <Table borderless>
                        <thead>
                          <tr>
                            <th>Artikl</th>
                            <th>Počet</th>
                            <th>Cena</th>
                            <th>Celkem</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.data.docNo ? (
                            <>
                              {this.state.data.articles?.map((a, idx) => (
                                <tr key={"cn_" + idx}>
                                  <td>{a.articleName}</td>
                                  <td>{a.articleQty}</td>
                                  <td>
                                    {this.state.data.invoiceCurrCode}{" "}
                                    {a.articlePrice}
                                  </td>
                                  <td>
                                    {this.state.data.invoiceCurrCode}{" "}
                                    {a.articlePrice * a.articleQty}
                                  </td>
                                </tr>
                              ))}
                            </>
                          ) : (
                            <tr>
                              <td>
                                <Placeholder animation="glow">
                                  <Placeholder xs={8} />
                                </Placeholder>
                              </td>
                              <td>
                                <Placeholder animation="glow">
                                  <Placeholder xs={8} />
                                </Placeholder>
                              </td>
                              <td>
                                <Placeholder animation="glow">
                                  <Placeholder xs={8} />
                                </Placeholder>
                              </td>
                              <td>
                                <Placeholder animation="glow">
                                  <Placeholder xs={8} />
                                </Placeholder>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <hr />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <div className="table-responsive">
                      <Table>
                        <tbody>
                          <tr>
                            <td style={{ width: "60%" }}>
                              <p id="text-warranty">
                                Záruka na provedený servisní úkon je v rozsahu:
                                tři měsíce na provedenou práci a tři měsíce na
                                použité náhradní díly. Souhlasem s tímto cenovým
                                návrhem zároveň vyjadřuji souhlas s ekologickou
                                likvidací nahrazených vadných náhradních dílů a
                                nepožaduji jejich vrácení. V případě nedostatku
                                náhradního dílu souhlasím s prodloužením doby
                                opravy o dobu nezbytně nutnou na jeho dodání.
                              </p>
                            </td>
                            <td className="d-flex justify-content-end me-4">
                              {this.state.data.docNo ? (
                                <p id="text-price">
                                  Mezisoučet: {this.state.data.invoiceCurrCode}{" "}
                                  {Number(this.state.subTotal).toFixed(2)}
                                  <br />
                                  DPH: {this.state.data.invoiceCurrCode}{" "}
                                  {Number(this.state.vatTotal).toFixed(2)}
                                  <br />
                                  <strong>Celkem</strong>:{" "}
                                  {this.state.data.invoiceCurrCode}{" "}
                                  {Number(this.state.total).toFixed(2)}
                                </p>
                              ) : (
                                <>
                                  <Placeholder animation="glow">
                                    <Placeholder xs={12} />
                                  </Placeholder>
                                  <Placeholder animation="glow">
                                    <Placeholder xs={12} />
                                  </Placeholder>
                                  <Placeholder animation="glow">
                                    <Placeholder xs={12} />
                                  </Placeholder>
                                </>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default _params(RepairPriceQuotation);
